var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4451 16.445C14.8781 17.6394 12.9701 18.3011 11.0001 18.3333C4.58339 18.3333 0.91674 11 0.91674 11C2.05697 8.87506 3.63844 7.01853 5.55509 5.555M9.07509 3.88665C9.70605 3.73896 10.3521 3.66513 11.0001 3.66665C17.4167 3.66665 21.0834 11 21.0834 11C20.527 12.0409 19.8634 13.021 19.1034 13.9241M12.9434 12.9433C12.6916 13.2135 12.388 13.4302 12.0507 13.5805C11.7134 13.7308 11.3492 13.8116 10.98 13.8182C10.6107 13.8247 10.244 13.7567 9.90154 13.6184C9.55913 13.4801 9.24805 13.2743 8.98691 13.0131C8.72582 12.752 8.51994 12.4409 8.3816 12.0985C8.24331 11.7561 8.17538 11.3893 8.18189 11.0201C8.1884 10.6508 8.26923 10.2867 8.41953 9.94937C8.56984 9.61202 8.78654 9.30842 9.05674 9.05665",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.91674 0.916656L21.0834 21.0833",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.31d0425b3aa85fb1037b1eb39bf8dcf4.svg";
export { ForwardRef as ReactComponent };